import { render, staticRenderFns } from "./PoljeUnosaTekst.vue?vue&type=template&id=364bddd9&scoped=true&"
import script from "./PoljeUnosaTekst.vue?vue&type=script&lang=js&"
export * from "./PoljeUnosaTekst.vue?vue&type=script&lang=js&"
import style0 from "./PoljeUnosaTekst.vue?vue&type=style&index=0&id=364bddd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364bddd9",
  null
  
)

export default component.exports